module.exports = __webpack_public_path__ + "img/16.dccb2f9d.webp";